import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import debounce from "lodash/debounce";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./FilterComponentStyles";

const UserFilter = ({
    hideTitle = false,
    value,
    onChange,
    selectMarginBottom = "20px",
    mode = "multiple",
    allowClear = true,
    placeholder = "Kullanıcı seçin",
    disabled = false,
    excludedRoles = [],
    additionalOptions = []
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [searchText, setSearchText] = useState("");
    const debounceTimeout = 400;

    const [loading, users] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.userStore.getUserList.bind(null, {
            limit: 20,
            page: 1,
            city: "all",
            role: "all",
            activity: true,
            searchText: searchText && searchText.toLocaleLowerCase("tr-TR"),
            excludedRoles: excludedRoles.join("%2C") || []
        }),
        dependencies: [searchText],
        initialCall: true
    });

    const onSearch = useMemo(() => {
        const loadOptions = value => {
            setSearchText(value);
        };
        return debounce(loadOptions, debounceTimeout);
    }, [debounceTimeout]);

    const allOptions = useMemo(() => {
        const allOptions = new Map();
        [...(users?.rows || []), ...(additionalOptions || [])].forEach(user => {
            allOptions.set(user._id, user);
        });
        return [...allOptions.values()];
    }, [JSON.stringify(users), JSON.stringify(additionalOptions)]);
    return (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.users", {ns: "common"})}</h5>}
            <SelectField
                loading={loading}
                data-testid="userFilter"
                value={value}
                onChange={onChange}
                disabled={disabled}
                mode={mode}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                showSearch
                onSearch={onSearch}
                placeholder={placeholder}
                mb={selectMarginBottom}
            >
                {arrayAlphabeticalSort([...allOptions.values()], "fullName").map(user => (
                    <SelectField.Option
                        key={user._id}
                        value={user._id}
                        data-testid="userFilter_option"
                    >
                        {user?.fullName}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default UserFilter;
